module.exports = __webpack_public_path__ + "img/slide4.6e42af47.jpg";